import React, { useEffect } from "react";
import { Menu } from "antd";
import { FormattedMessage } from "react-intl";
import MenuWrapper from "./SubMenu.style";
import ChildrenAnimationWrapper from "../animations/ChildrenAnimationWrapper";
import AnimationChildWrapper from "../animations/AnimationChildWrapper";

const PageAnchor = (props) => {
  const { onMenuSelect, items, selectedKeys, listStyle } = props;

  useEffect(() => {
    if (selectedKeys) {
      document.getElementById(selectedKeys).scrollIntoView();
    }
  }, [selectedKeys]);

  return (
    <MenuWrapper>
      <ChildrenAnimationWrapper listStyle={listStyle}>
        <Menu
          mode="inline"
          defaultSelectedKeys={[items[0].name]}
          defaultOpenKeys={[items[0].name]}
          style={{ height: "100%", border: "none" }}
          className="light"
          selectedKeys={selectedKeys}
          onSelect={onMenuSelect}
          items={items.map((item, i) => ({
            label: (
              <div>
                {item.icon}
                <FormattedMessage id={`app.${item.category}.${item.name}`} />
              </div>
            ),
            key: item.name,
          }))}
        />
      </ChildrenAnimationWrapper>
    </MenuWrapper>
  );
};

export default PageAnchor;
